import { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import MapViewComponent from "./MapViewComponent";

const ProfileComponent = ({customerData, markers, sendShowMapDataFromChild}) => {
    const { t } = useTranslation();
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const revenueData = JSON.parse(customerData.revenue_Detail);
    const salePerson = JSON.parse(customerData.salesPerson);
    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        notation: "compact",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currency: 'EUR',
        currencyDisplay: 'narrowSymbol'
    });
    const formatter1 = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const [showAllPartner, setShowAllPartner] = useState(false);
    const [showAllSalePerson, setShowAllSalePerson] = useState(false);
    const [showOperatingHours, setShowOperatingHours] = useState(false);
    const [showWorkingHour, setShowWorkingHour] = useState(false);
    const [workingHour, setWorkingHour] = useState('Working Hours');
    const [workingHourId, setWorkingHourId] = useState(1);

    const handleShowMap = (data) => {
        sendShowMapDataFromChild(data);
    };
    const handleWorkingHour = (e, value) => {
        e.preventDefault();
        setWorkingHour(value.title);
        setWorkingHourId(value.id)
        setShowWorkingHour(!showWorkingHour);
    };

    const filteredHours = customerData.operating_hoursList
    ? customerData.operating_hoursList.filter(
            hour => hour.typeOfCalendarID === workingHourId
        )
    : [];

    // Group the filtered hours by dayOfTheWeek
    const groupedHours = filteredHours.reduce((acc, curr) => {
        const day = curr.dayOfTheWeek;
        if (!acc[day]) {
            acc[day] = [];
        }
        acc[day].push(curr);
        return acc;
    }, {});

    // Order days as desired (optional)
    const daysOrder = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
    ];
    const sortedDays = Object.keys(groupedHours).sort(
        (a, b) => daysOrder.indexOf(a) - daysOrder.indexOf(b)
    );

    // Calculate total weekly operating hours in minutes, then convert to hours.
    const totalMinutes = filteredHours.reduce((sum, item) => {
        const start = moment(item.fromTime);
        const end = moment(item.toTime);
        // Calculate difference in minutes
        const diff = end.diff(start, 'minutes');
        return sum + diff;
    }, 0);
    const totalHours = totalMinutes / 60;


    return (
        <div className="relative">
            <div className="space-y-2 sm:space-y-4">
                <div className="grid lg:grid-cols-2 gap-2 sm:gap-4">
                    {/* communication box */}
                    <div className="bg-white border border-white rounded-lg py-2 shadow-around">
                        <div className="px-2 flex items-center justify-between">
                            <h1 className="text-base font-semibold capitalize">{ t('communication details')}</h1>
                            <img className="bg-blue-light2 rounded-lg p-2" src="../../assets/icons/profile/mail.svg" alt="mail" />
                        </div>
                        <div className="mt-3 border-t border-background-normal"></div>
                        <div className="px-2 text-right divide-y divide-dashed grid grid-cols-1">
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img className="ml-1" src="../../assets/icons/profile/icon/profile.svg" alt="profile" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('customer title')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{(customerData.customerTitle && customerData.customerTitle !== "NULL") ? customerData.customerTitle : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/contact.svg" alt="contact" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('contact person')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.contactName ? customerData.contactName : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/phone.svg" alt="phone" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('phone number')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{(customerData.phone && customerData.phone !== "NULL" && customerData.phone !== "NA") ? customerData.phone : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/mobile.svg" alt="mobile" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('mobile number')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.mobileNumber ? customerData.mobileNumber : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/email.svg" alt="email" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('email address')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words">{customerData.email ? customerData.email : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center pt-3 pb-2 lg:pb-0">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/email.svg" alt="email" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('sec. email address')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words">{customerData.secondaryEmail ? customerData.secondaryEmail : '--'}</div>
                            </div>
                        </div>
                    </div>
                    {/* financial box */}
                    <div className="bg-white border border-white rounded-lg py-2 shadow-around">
                        <div className="px-2 flex items-center justify-between">
                            <h1 className="text-base font-semibold capitalize">{ t('financial details')}</h1>
                        </div>
                        <div className="mt-3 border-t border-background-normal"></div>
                        <div className="px-2 text-right divide-y divide-dashed grid grid-cols-1">
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/profile.svg" alt="profile" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('balance')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.balance ? (formatter1.format(customerData.balance)+' €') : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/money.svg" alt="money" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('previous turnover')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.previousTurnover ? (formatter1.format(customerData.previousTurnover)+' €'): '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/money.svg" alt="money" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('turnover')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.turnover ? (formatter1.format(customerData.turnover)+' €') : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/calendar.svg" alt="calendar" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('last order date')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.lastOrderDate ? moment(customerData.lastOrderDate).format('LL') : '--'}</div>
                            </div>
                            {/* <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/calendar.svg" alt="calendar" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('last payment date')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.noofdeliverydays ? customerData.noofdeliverydays : '--'}</div>
                            </div> */}
                        </div>
                    </div>
                    {/* business box */}
                    <div className="bg-white border border-white rounded-lg py-2 shadow-around">
                        <div className="px-2 flex items-center justify-between">
                            <h1 className="text-base font-semibold capitalize">{ t('business details')}</h1>
                        </div>
                        <div className="mt-3 border-t border-background-normal"></div>
                        <div className="px-2 text-right divide-y divide-dashed grid grid-cols-1">
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/partner.svg" alt="partner" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('main partner')}</span>
                                </div>
                                <div className="space-y-1">
                                    <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">
                                        {(customerData.mainPartner.length > 0) ? customerData.mainPartner[0].Name : '--'}
                                    </div>
                                    {(customerData.partnerList.length > 0) ?
                                        <div onClick={(e) => setShowAllPartner(!showAllPartner)} className="text-center underline text-blue-normal text-xs capitalize font-semibold cursor-pointer">{ t("view partners")}</div>
                                    : null}
                                </div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/wallet.svg" alt="wallet" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('payment method')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.paymenttype ? customerData.paymenttype : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/flag.svg" alt="flag" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('category')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.category ? customerData.category : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/business.svg" alt="business" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('business unit')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.businessUnit ? customerData.businessUnit : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/sale.svg" alt="sale" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('salesman')}</span>
                                </div>
                                <div className="text-[10px] sm:text-xs break-words sm:w-auto">
                                    {customerData.salesPerson ? <div onClick={(e) => setShowAllSalePerson(!showAllSalePerson)} className="text-center underline text-blue-normal text-xs capitalize font-semibold cursor-pointer">{ t("view sales person")}</div> : '--'}
                                </div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/type.svg" alt="type" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('customer type')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.customertype ? customerData.customertype : '--'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/pin.svg" alt="pin" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('prospect customer')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{customerData.prospect_customer === true ? 'true' : 'false'}</div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/calendar.svg" alt="calendar" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('operating periods')}</span>
                                </div>
                                <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">
                                {customerData.operating_periodsList && customerData.operating_periodsList.length > 0
                                    ? customerData.operating_periodsList
                                        .map(period => `${moment(period.fromDate).format('MMM')} - ${moment(period.toDate).format('MMM')}`)
                                        .join(', ')
                                    : '--'}
                                </div>
                            </div>
                            <div className="flex justify-between items-center py-3">
                                <div className="flex items-center space-x-2">
                                    <span><img src="../../assets/icons/profile/icon/hour.svg" alt="hour" /></span>
                                    <span className="text-light-400 text-[10px] sm:text-xs font-normal capitalize"> { t('operating hours')}</span>
                                </div>
                                <div className="text-[10px] sm:text-xs break-words sm:w-auto">
                                    {customerData.operating_hoursList && customerData.operating_hoursList ?
                                        <div onClick={(e) => setShowOperatingHours(!showOperatingHours)} className="text-center underline text-blue-normal text-xs capitalize font-semibold cursor-pointer">{ t("view operating hours")}</div>
                                        :
                                        <div className="font-medium text-[10px] sm:text-xs break-words sm:w-auto">{'--'}</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* address */} 
                    <div className="bg-white border border-white rounded-lg p-2 shadow-around">
                        <div>
                            <div className="flex items-center justify-between">
                                <h1 className="text-base font-semibold capitalize">{ t('address details')}</h1>
                            </div>
                            <div className="flex items-center space-x-4 justify-between">
                                <div className="text-light-400 text-xs">{customerData.address}, {customerData.city}, {customerData.state}, {customerData.country}, {customerData.postalCode}</div>
                                <img onClick={(e) => (customerData.addressLatitude !== "NULL" ? handleShowMap(true) : null)} className={(customerData.addressLatitude !== "NULL" ? "cursor-pointer" : "") + " bg-blue-light2 rounded-lg py-2 px-2 w-8 h-8 hidden sm:block"} src="../../assets/icons/profile/icon/redirect.svg" alt="redirect" />
                                <img onClick={(e) => (customerData.addressLatitude !== "NULL" ? handleShowMap(true) : null)} className={(customerData.addressLatitude !== "NULL" ? "cursor-pointer" : "") + " bg-blue-light2 rounded-lg py-2 px-3 block sm:hidden"} src="../../assets/icons/profile/location.svg" alt="location" />
                            </div>
                        </div>
                        <div className="sm:block hidden mt-1">
                            <MapViewComponent markers={markers} draggable={false}/>
                        </div>
                    </div>
                </div>
            </div>
            {showAllPartner
                ?
                    <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                        <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                            <div className="fixed inset-0 transition-opacity">
                                <div className="absolute inset-0 bg-gray-900 opacity-75" />
                            </div>
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                            <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-xs w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                                <div className="bg-white py-4 px-4 space-y-3">
                                    <div className="flex justify-between items-center">
                                        <div className="font-semibold text-sm sm:text-lg first-letter:capitalize">{ t('partners list')}</div>
                                        <div className="cursor-pointer" onClick={(e) => setShowAllPartner(!showAllPartner)}>
                                            <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                        </div>
                                    </div>
                                    <div>
                                        <ul>
                                            {customerData.partnerList.map((partner, index) => (
                                                <li className="text-sm" key={`partner${index}`}> {index+1}. {partner.Name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {showAllSalePerson
                ?
                    <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                        <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                            <div className="fixed inset-0 transition-opacity">
                                <div className="absolute inset-0 bg-gray-900 opacity-75" />
                            </div>
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                            <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-xs w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                                <div className="bg-white py-4 px-4 space-y-3">
                                    <div className="flex justify-between items-center">
                                        <div className="font-semibold text-sm sm:text-lg capitalize">{ t('sales person list')}</div>
                                        <div className="cursor-pointer" onClick={(e) => setShowAllSalePerson(!showAllSalePerson)}>
                                            <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                        </div>
                                    </div>
                                    <div>
                                        <ul>
                                            {salePerson.map((sale, index) => (
                                                <li className="text-sm" key={`sale${index}`}> {index+1}. {sale.FirstName}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {showOperatingHours
                ?
                    <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                        <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                            <div className="fixed inset-0 transition-opacity">
                                <div className="absolute inset-0 bg-gray-900 opacity-75" />
                            </div>
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                            <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-sm w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                                <div className="bg-white py-4 space-y-3">
                                    <div className="flex justify-between items-center px-4">
                                        <div className="font-semibold text-sm sm:text-lg capitalize">{ t('operating hours')}</div>
                                        <div className="cursor-pointer" onClick={(e) => setShowOperatingHours(!showOperatingHours)}>
                                            <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                        </div>
                                    </div>
                                    <div className="mt-3 border-t border-background-normal"></div>
                                    <div className="grid grid-cols-2 gap-2 space-x-2 px-4">
                                        <div className="relative">
                                            <div onClick={(e) => setShowWorkingHour(!showWorkingHour)} className="py-2 px-2 flex items-center space-x-2 rounded-lg text-black bg-gray-dark3 cursor-pointer">
                                                <img src="../../assets/icons/profile/icon/hour.svg" alt="hour" />
                                                <span className="capitalize font-medium">{workingHour}</span>
                                                <img src="../../assets/icons/profile/icon/down-arrow.svg" alt="arrow" />
                                            </div>
                                            {
                                                showWorkingHour
                                                ? 
                                                    <ul className="absolute z-30 bg-white shadow-md top-10 right-0 rounded-md w-full text-xs">
                                                        {customerData.typeOfCalendarList &&
                                                            customerData.typeOfCalendarList.map((hours, index) => (
                                                                <li key={`type${index}`} onClick={(e) => handleWorkingHour((e), hours)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{hours.title}</li>
                                                            ))
                                                        }
                                                    </ul>  
                                                : null
                                            }
                                        </div>
                                        <div className="rounded-lg py-2 px-2 border border-background-normal text-center text-black">{totalHours > 0 ? `${totalHours} hour/week` : '0 hour/week'}</div>
                                    </div>
                                    <div className="px-4 overflow-x-auto min-h-44 max-h-64 sm:max-h-96">
                                        {filteredHours.length > 0 
                                        ? 
                                            <table className="w-full text-xs">
                                                <thead className="text-gray-normal border border-background-normal">
                                                    <tr>
                                                        <th scope="col" className="border-r border-background-normal font-normal py-4 px-4">
                                                            <div className="flex">
                                                                <div className="mr-2 uppercase">
                                                                    { t('day')}
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th scope="col" className="font-normal py-4 px-4">
                                                            <div className="flex">
                                                                <div className="mr-2 uppercase">
                                                                    { t('time')}
                                                                </div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sortedDays.length > 0 ? (
                                                        sortedDays.map((day, index) => (
                                                            <tr key={`day${index}`}>
                                                                <td className="py-4 px-4 border border-background-normal">
                                                                    {day}
                                                                </td>
                                                                <td className="py-4 px-4 border border-background-normal">
                                                                    {groupedHours[day].map((item, index) => (
                                                                        <div key={`workinghours${index}`}>{moment(item.fromTime).format('h:mm A')} - {moment(item.toTime).format('h:mm A')}</div>
                                                                    ))}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="2" className="py-4 px-4 border border-background-normal">
                                                                --
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        :
                                            <div className="text-center py-4 font-medium uppercase">{ t('no records available')}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
        </div>
    )
}

export default ProfileComponent;